import { render } from "./AddModuleModal.vue?vue&type=template&id=4587e481&scoped=true&ts=true"
import script from "./AddModuleModal.vue?vue&type=script&lang=ts"
export * from "./AddModuleModal.vue?vue&type=script&lang=ts"

import "./AddModuleModal.vue?vue&type=style&index=0&id=4587e481&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4587e481"]])

export default __exports__